import axios from "axios";
import Victim from "@/apis/Victim";

//State
const state = {
  victimsCount: 0,
  lastVictims: 0,
  isInfoLoading: true,
  isTableLoading: true,
  standardVictims: [],
  privateVictims: [],
  victims: [],
  isFetched: false,
};

//Getters
const getters= {

  //All Victims
  getAllVictims(state){
    return state.victims
  },

  //Total Victims Count
  getTotalCount(state) {
    return state.victimsCount
  },

  //Today Victims Count
  getTodayCount(state) {
    return state.lastVictims
  },

  //Info isLoading
  isInfoLoading(state) {
    return state.isInfoLoading
  },

  //Table isLoading
  isTableLoading(state) {
    return state.isTableLoading
  },

  //Victims isFetched
  isFetched(state){
    return state.isFetched;
  }
};

//Actions
const actions = {

  /**
  * Get victims from API
  *  => Get Standard/Private Victims 
  *     and then join them in one table
  */
  async fetchVictims({commit, dispatch}){
    await axios.all(Victim.getAll()).then(axios.spread((...responses) => {
      const StandardVictims = responses[0].data;
      const PrivateVictims = responses[1].data;

      commit('SET_STANDARD_VICTIMS', StandardVictims);
      commit('SET_PRIVATE_VICTIMS', PrivateVictims);
      commit('SET_ALL_VICTIMS');
      commit('SET_STANDARD_VICTIMS', []);
      commit('SET_PRIVATE_VICTIMS', []);
      commit('SET_TABLE_LOADING', false);
      commit('SET_VICTIM_FETCHED', true);

      dispatch('updateInfos');
    }))
  },

  /**
  * Delete selected Victims
  *  => Split: Standard / Private
  *  => Delete from API then from VUEX
  */
  async deleteVictims({commit, dispatch}, selected){
    commit('SET_TABLE_LOADING', true);
    
    //Split selected victims : true => Private / false => Standard
    let splited = [];
    if(selected.length > 0) {
      splited = selected.reduce((r, a) => {
        r[a.isPrivate] = [...r[a.isPrivate] || [], a];
        return r;
      },{});
    }

    let requests = [];

    //Standard Victims
    if(splited.false){
      splited.false = splited.false.map(a => a.id); //Get only id
      const requestStandard = Victim.deleteStandards(splited.false);
      requests.push(requestStandard);
    }

    //Private Victims
    if(splited.true){
      splited.true = splited.true.map(a => a.id); //Get only id
      const requesPrivate = Victim.deletePrivates(splited.true);
      requests.push(requesPrivate);
    }

    await axios.all([requests]).then(axios.spread((...responses) => {

      //Delete Standard victims from VUEX
      if(splited.false){
          commit('DELETE_STANDARD_VICTIMS', splited.false);
      }

      //Delete Private victims from VUEX
      if(splited.true){
        commit('DELETE_PRIVATE_VICTIMS', splited.true);
      }

      dispatch('updateInfos'); //Update info
      commit('SET_TABLE_LOADING', false); //Stop Loading
    }))
  },

  /**
  * Add new Victim to VUEX
  */
  addVictim({commit, dispatch} , vic){
    vic.created_at = new Date(vic.created_at);
    vic.idFront = state.victims.length;

    commit('SET_NEW_VICTIM', vic);
    dispatch('updateInfos');
  },

  /**
  * Update total/today Victims
  */
  updateInfos({commit}){
    commit('SET_INFO_LOADING', true);
    commit('SET_TOTAL_COUNT');
    commit('SET_TODAY_COUNT');
    commit('SET_INFO_LOADING', false);
  },

  /**
  * Reset Default State
  */
  reset({commit}){
    commit('SET_VICTIM_FETCHED', false);
    commit('SET_STANDARD_VICTIMS', []);
    commit('SET_PRIVATE_VICTIMS', []);
    commit('SET_ALL_VICTIMS');
    commit('SET_TABLE_LOADING', true);
    commit('SET_INFO_LOADING', true);
    commit('SET_TOTAL_COUNT');
    commit('SET_TODAY_COUNT');
  }
  
};

//Mutations
const mutations = {

  //Push new Victim
  SET_NEW_VICTIM (state, value){
    state.victims.push(value);
  },

  //Add custom properties
  SET_STANDARD_VICTIMS (state, standardVic) {
      //Standard Victims
      if(standardVic.length > 0){
          standardVic.map(function(value) {
            value.isPrivate = false;
            value.created_at = new Date(value.created_at);
          })
      }
      state.standardVictims = standardVic;
  },

  //Add custom properties
  SET_PRIVATE_VICTIMS (state, privateVic) {
      //Private Victims
      if(privateVic.length > 0){
          privateVic.map(function(value) {
            value.isPrivate = true;
            value.created_at = new Date(value.created_at);
          })
      }
      state.privateVictims = privateVic;
  },

  //Join Standard and Private Victims
  SET_ALL_VICTIMS(state){
    state.victims = [...state.standardVictims, ...state.privateVictims];
    state.victims.map(function(victim, index){
      victim.idFront = index;
    });
  },

  /** 
  * Remove Standard victims
  * from victims table
  */
  DELETE_STANDARD_VICTIMS(state, ids){
    state.victims = state.victims.filter((vic) => 
      vic.isPrivate || !ids.includes(vic.id) 
    );
  },

  /** 
  * Remove Private victims
  * from victims table
  */
  DELETE_PRIVATE_VICTIMS(state, ids){
    state.victims = state.victims.filter((vic) => 
      !vic.isPrivate || !ids.includes(vic.id) 
    );
  },

  //Total victims counter
  SET_TOTAL_COUNT (state) {
    state.victimsCount = state.victims.length
  },

  //Today victims counter
  SET_TODAY_COUNT (state) {
    state.lastVictims = state.victims.filter(
      (v) => {
        return v.created_at >= new Date(new Date().setDate(new Date().getDate()-1));
      }
    ).length;
  },

  //Info isLoading
  SET_INFO_LOADING (state, value) {
    state.isInfoLoading = value
  },

  //Datatable isLoading
  SET_TABLE_LOADING (state, value) {
    state.isTableLoading = value
  },

  SET_VICTIM_FETCHED(state, value){
    state.isFetched = value
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}